import styled from 'styled-components';
import { sizeVars } from '@routific/hive/v5';

const PackagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizeVars.space[100]};
`;

export default PackagesContainer;
